import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";
const apiEndpoint = apiUrl + "/sales/pos/";

export function getPosSales(
  outletID = 0,
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(
    apiEndpoint + `sales-pos-list/${outletID}/${dateFrom}/${dateTo}`
  );
}

export function getPosSalesDetail(salesPosID = 0) {
  return http.get(apiEndpoint + "sales-pos-detail/" + salesPosID);
}

export function savePosSales(posSales) {
  return http.post(apiEndpoint, posSales);
}

export function savePosSalesReturn(salesReturn) {
  return http.post(apiEndpoint + "/sales-return", salesReturn);
}
